import { useQuery } from '@tanstack/react-query';

import { courseConst, ICourse } from 'modules/courses';
import { $apiV2 } from 'modules/global';

export const getTopCourses = () => async () => {
  const { data } = await $apiV2.get(`/teacher-course/top-courses`);

  return { topCourses: data?.data };
};

export const useTopCourses = () => {
  const { data, ...args } = useQuery<{ topCourses: ICourse[] }>({
    queryKey: [courseConst.queryKeys.TOP_COURSES],
    queryFn: getTopCourses()
  });

  return { ...data, ...args };
};
